/**
 * Address History Mock Page
 *
 * A simple wrapper page for the mock AddressHistoryMock component.
 * This page is rendered at the /address-history-mock route.
 */

import { AddressHistoryMock } from "../components/addressHistoryMock/AddressHistoryMock";

export function AddressHistoryMockPage() {
  return <AddressHistoryMock />;
}
